<template>
  <splitpanes class="default-theme" style="background-color: whitesmoke">
    <pane min-size="40" size="60">
      <div class="my-box">
        <el-row :gutter="5" style="margin-bottom: 3px">
          <el-col :span="24">
            <el-input style="width: 150px" v-model="formData.code" placeholder="打印模板编码" disabled></el-input>
            <el-input style="width: 150px" v-model="formData.name" placeholder="打印模板名称"></el-input>
            <el-cascader style="width: 150px" v-model="formData.dir_id" placeholder="请选择目录" :options="dirList" :show-all-levels="false"
                         :props="cascaderProps" clearable>
            </el-cascader>
            <el-input style="width: 150px" v-model="formData.remark" placeholder="打印模板备注"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="5" style="margin-bottom: 3px">
          <el-col :span="24">
            <el-button :disabled="formData.status!='edit'" @click="saveTemplate">保存</el-button>
            <el-button :disabled="formData.status=='edit'" @click="versionUp">升版</el-button>
            <el-button :disabled="formData.status=='release'" @click="releaseTemplate">发放</el-button>
            <el-button :disabled="formData.status!='release'" @click="abortTemplate">废弃</el-button>
            <el-button @click="deleteTemplate">删除</el-button>
          </el-col>
        </el-row>

        <KfJsonEditor style="width: 100%;height: 100%;margin-top: 2px;margin-bottom: 5px" v-model="formData.content" placeholder="打印模板JSON配置对象"></KfJsonEditor>
      </div>
    </pane>

    <pane min-size="30" style="background-color:white">
      <el-tabs v-model="activeName" class="demo-tabs">
        <el-tab-pane label="调试" name="debug" style="height: 100%">

          <splitpanes class="default-theme" style="background-color: white" horizontal>
            <pane min-size="15" size="30">
              <div style="display: inline-flex">
                <el-button @click="preview" style="width: 100px;margin-left: 5px">预览</el-button>
                <el-button @click="previewAndPrint" style="width: 100px;margin-left: 5px">预览并打印</el-button>
              </div>
              <KfJsonEditor style="min-height: 300px;height: 100%;margin-top: 2px;margin-bottom: 5px" placeholder="提示：这里输入模板里data_key指定参数数据，对象型JSON格式 {} "
                            v-model="debugJson"></KfJsonEditor>
            </pane>

            <pane min-size="15">
              <el-row style="padding: 5px;background-color: #f2f2f2">模板效果预览</el-row>
              <div v-if="printData.preview_image" class="preview-image">
                <el-image style="width: 100%" :src="'data:image/jpeg;base64,'+printData.preview_image"></el-image>
              </div>
            </pane>
          </splitpanes>

        </el-tab-pane>
      </el-tabs>
    </pane>
  </splitpanes>
</template>

<script>
import FrameJavaDebug from "./FrameJavaDebug.vue";
import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import {nanoid} from "nanoid";

export default {
  name: "FramePrintTemplateEditor",
  inject: ['$fn'],
  components: {Splitpanes, Pane, FrameJavaDebug},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        id: this.parentData.id,
        code: this.parentData.code,
        name: this.parentData.name,
        content: this.parentData.content,
        dir_id: this.parentData.dir_id,
        remark: this.parentData.remark
      },
      backContent: this.parentData.content,
      debugJson: '',
      activeName: 'debug',
      dirList: [],
      cascaderProps: {
        emitPath: false,
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      },
      printData: {}
    }
  },
  mounted() {
    this.getDirTree()
    this.loadInfo()

  },
  methods: {
    //获取行业类型
    async getDirTree() {
      this.dirList = await this.$http('sysDirService.getTree', {'dir_def_id': 'sys_define'})
    },
    async loadInfo() {
      this.formData = await this.$http('sysProgramService.getById', {'id': this.formData.id})
      this.backContent = this.formData.content;
    },
    async saveTemplate() {

      if (!this.formData.code) {
        this.$message.error('打印模板编码为空')
        return;
      }

      if (!this.formData.name) {
        this.$message.error('打印模板名称为空')
        return;
      }

      if (!this.formData.content) {
        this.$message.error('打印模板内容为空')
        return;
      }

      //保存
      await this.$http('sysDefineService.edit', this.formData);
      this.$message.success('保存成功');
      await this.loadInfo()
      this.$fn.search();

    },
    async versionUp() {
      this.formData.id = await this.$http('sysDefineService.versionUp', this.formData);
      this.$message.success('升版成功')
      await this.loadInfo()
      this.$fn.search();
    },
    async releaseTemplate() {
      this.$confirm('你确定要发放【' + this.formData.code + '】吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$http('sysDefineService.setStatus(release)', this.formData);
        this.$message.success('发放成功')
        await this.loadInfo()
        this.$fn.search();
      });
    },
    abortTemplate() {
      this.$confirm('你确定要废弃【' + this.formData.code + '】吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$http('sysDefineService.setStatus(abort)', this.formData);
        this.$message.success('废弃成功')
        await this.loadInfo()
        this.$fn.search();
      });
    },
    async deleteTemplate() {
      this.$confirm('你确定要删除【' + this.formData.code + '】吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$http('sysDefineService.delete', this.formData);
        this.$message.success('删除成功')
        this.$fn.search();
        this.$fn.closeWindow();
      });
    },
    async preview() {
      if (!this.formData.code || this.formData.code.length == 0) {
        this.$message.error('打印模板编码为空')
        return;
      }

      if (!this.debugJson) {
        this.debugJson = '{}'
      }

      let params;
      try {
        params = JSON.parse(this.debugJson);
      } catch (e) {
        this.$message.error('参数数据格式错误，必须为JSON对象格式')
        return;
      }
      if (!this.isPlainObject(params)) {
        this.$message.error('参数数据格式错误，必须为JSON对象格式')
        return;
      }

      if (this.backContent && this.backContent != this.formData.content) {
        await this.saveTemplate()
      }

      params.template_id = this.formData.code;

      this.printData = await this.$http('sysPrintTemplateService.debug', params)

    },
    async previewAndPrint() {
      await this.preview()

      this.printData.request_id = nanoid()
      await this.$http(process.env.VUE_APP_PRINT_URL, this.printData, false).then(data => {
        this.$message.error('打印请求已发送到打印机');
      }, errMsg => {
        this.$message.error('调用打印机失败：' + errMsg);
      });


    },
    isPlainObject(val) {
      return (
          val !== null &&
          typeof val === 'object' &&
          !Array.isArray(val) &&
          Object.prototype.toString.call(val) === '[object Object]'
      );
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}


.my-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 2px;
}


.right-container {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;

  .empty-tip {
    font-size: 24px;
    color: #ccc;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}

.send-box {
  display: flex;
  padding: 20px 20px 0 20px;
}

.msg-list {
  flex: 1;
  overflow: auto;

  .msg-item {
    display: flex;
    padding: 20px 20px 0 20px;

    .icon {
      width: 50px;
      text-align: center;
    }

    .content-box {
      flex: 1;
      white-space: pre-wrap;
      border-bottom: 1px dashed #ccc;
      padding-bottom: 20px;
    }

    .content-box .content {
      border-radius: 15px;
      padding: 10px;
    }

    .content-box.user {
      display: flex;
      justify-content: flex-end;
    }

    .content-box.user .content {
      background-color: AliceBlue;
    }

    .content-box.assistant {

    }

    .content-box.assistant .content {
      background-color: #F4F4F4;
    }

  }

  .msg-item:last-child .content-box {
    border-bottom: none;
  }

  .my-sidebar {
    width: 40px; /* 设置工具条的宽度 */
    background-color: #fff; /* 背景颜色 */
    display: flex;
    flex-direction: column; /* 垂直排列图标 */
    align-items: center; /* 水平居中 */
    justify-content: center; /* 垂直居中 */
    border-right: solid 1px #ccc;
  }

  .sidebar-icon {
    margin-bottom: 5px; /* 图标之间的间距 */
  }

  .right-main {
    flex-grow: 1; /* 主区域占满剩余空间 */
    background-color: #e5e5e5; /* 背景颜色 */
  }

  .my-icon-active {
    color: #87CEFA;
  }

  .blue-icon {
    color: blue;
  }
}

.demo-tabs {
  height: 100%;
}

.preview-image {
  padding: 20px;
  background-color: aliceblue;
  height: 100%;
  overflow: auto;
}

</style>